
export const getDaysRemaining = (endDateString) => {
    if (!endDateString) return "N/A";
    const endDate = new Date(endDateString);
    const today = new Date();
    const timeDiff = endDate - today;
    const daysRemaining = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return daysRemaining;
};

export const getDaysRemainingColor = (days) => {
    if (days <= 7) return "text-red-600 font-bold";
    if (days <= 15) return "text-yellow-600 font-semibold";
    return "text-green-600";
};

export const thirtyDaysFromNow = new Date();
    thirtyDaysFromNow.setDate(thirtyDaysFromNow.getDate() + 30);
    const formattedExpiryDate = thirtyDaysFromNow.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
});

// Process account status counts
export const processStatusCounts = (data) => {
  if (!data || !Array.isArray(data)) {
    return { healthy: 0, atRisk: 0, inactive: 0 };
  }
  
  return data.reduce(
    (acc, org) => {
      if (org.status === "Healthy") acc.healthy += 1;
      else if (org.status === "At Risk") acc.atRisk += 1;
      else if (org.status === "Inactive") acc.inactive += 1;
      return acc;
    },
    { healthy: 0, atRisk: 0, inactive: 0 }
  );
};

// Create chart data from status counts
export const createChartData = (statusCounts) => {
  return [
    { name: "Healthy", value: statusCounts.healthy },
    { name: "At Risk", value: statusCounts.atRisk },
    { name: "Inactive", value: statusCounts.inactive },
  ];
};